/**
 * Owner: Masa Bayu
 * File: AdamEntryPanel.tsx
 * Date:Time: 2026-09-16 18:53
 * Description: T8-E7 AdamEntryContext UI — gated; ≠ Own ADAM intelligence.
 */

import { useId, useState } from 'react';
import {
  evaluateDemoAdamAvailable,
  evaluateDemoAdamBlocked,
  getDemoAdamEntry,
  getDemoAdvancedStatus,
  resetDemoAdvancedStore,
} from './demo-advanced-store';

export interface AdamEntryPanelProps {
  readonly onNavigate: (path: string) => void;
}

export function AdamEntryPanel({ onNavigate }: AdamEntryPanelProps) {
  const statusId = useId();
  const [status, setStatus] = useState(() => getDemoAdvancedStatus());
  const [entry, setEntry] = useState(() => getDemoAdamEntry());

  const refresh = (next: string) => {
    setStatus(next);
    setEntry(getDemoAdamEntry());
  };

  return (
    <section className="route-panel adam-entry" aria-labelledby="adam-entry-title">
      <h2 id="adam-entry-title">ADAM · entry</h2>
      <p>
        AdamEntryContext gates require entitlement and Reader context. QXRead Integrates ADAM; it
        does not Own ADAM intelligence.
      </p>
      <p id={statusId} role="status" aria-live="polite" className="adam-entry__status">
        {status}
        {entry !== null ? ` · gate ${entry.gate}` : ''}
      </p>
      <div role="group" aria-label="ADAM entry actions" className="adam-entry__controls">
        <button
          type="button"
          onClick={() => {
            refresh(evaluateDemoAdamAvailable());
          }}
        >
          Evaluate available
        </button>
        <button
          type="button"
          onClick={() => {
            refresh(evaluateDemoAdamBlocked());
          }}
        >
          Evaluate blocked
        </button>
        <button
          type="button"
          onClick={() => {
            resetDemoAdvancedStore();
            refresh(getDemoAdvancedStatus());
          }}
        >
          Reset demo
        </button>
        <button
          type="button"
          onClick={() => {
            onNavigate('/offline');
          }}
        >
          PWA
        </button>
      </div>
      {entry !== null ? (
        <ul aria-label="ADAM entry facts" className="adam-entry__facts">
          <li>{`gate=${entry.gate}`}</li>
          <li>{`ownsAdamIntelligence=${String(entry.ownsAdamIntelligence)}`}</li>
          <li>{`mutatesPublication=${String(entry.mutatesPublication)}`}</li>
          <li>{`inventsEntitlement=${String(entry.inventsEntitlement)}`}</li>
        </ul>
      ) : null}
    </section>
  );
}
